var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4672_1190)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.22376 4.9281C9.44194 4.80526 9.68811 4.74072 9.9385 4.74072C10.1889 4.74072 10.4351 4.80526 10.6532 4.9281C10.8714 5.05094 11.0543 5.22794 11.1841 5.44203L11.1853 5.44391L15.6785 12.9451L15.6818 12.9505C15.809 13.1708 15.8763 13.4206 15.877 13.675C15.8777 13.9294 15.8118 14.1795 15.6858 14.4005C15.5599 14.6215 15.3782 14.8057 15.159 14.9347C14.9397 15.0637 14.6905 15.1331 14.4361 15.1359L14.4318 15.1359L5.44087 15.1359C5.1865 15.1331 4.93729 15.0637 4.71805 14.9347C4.4988 14.8057 4.31715 14.6215 4.19118 14.4005C4.0652 14.1795 3.99929 13.9294 4.00001 13.675C4.00072 13.4206 4.06803 13.1708 4.19524 12.9505L4.19845 12.9451L8.69173 5.44391L9.03134 5.64734L8.69286 5.44203C8.82272 5.22794 9.00557 5.05094 9.22376 4.9281ZM9.37036 5.85183L9.36985 5.85268L4.87953 13.3489C4.82236 13.4489 4.79213 13.562 4.7918 13.6772C4.79148 13.7933 4.82157 13.9075 4.87907 14.0084C4.93658 14.1093 5.01951 14.1934 5.1196 14.2523C5.21913 14.3109 5.33219 14.3425 5.44764 14.3441H14.4294C14.5448 14.3425 14.6579 14.3109 14.7574 14.2523C14.8575 14.1934 14.9404 14.1093 14.9979 14.0084C15.0554 13.9075 15.0855 13.7933 15.0852 13.6772C15.0849 13.562 15.0546 13.4489 14.9975 13.3489L10.5071 5.85268L10.5066 5.85183C10.4474 5.75448 10.3641 5.67398 10.2648 5.61806C10.1652 5.56198 10.0528 5.53252 9.9385 5.53252C9.82419 5.53252 9.71182 5.56198 9.61221 5.61806C9.51289 5.67398 9.42961 5.75448 9.37036 5.85183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93869 7.97809C10.1573 7.97809 10.3346 8.15534 10.3346 8.37399V10.496C10.3346 10.7146 10.1573 10.8919 9.93869 10.8919C9.72004 10.8919 9.54279 10.7146 9.54279 10.496V8.37399C9.54279 8.15534 9.72004 7.97809 9.93869 7.97809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54279 12.6179C9.54279 12.3993 9.72004 12.222 9.93869 12.222H9.944C10.1626 12.222 10.3399 12.3993 10.3399 12.6179C10.3399 12.8366 10.1626 13.0138 9.944 13.0138H9.93869C9.72004 13.0138 9.54279 12.8366 9.54279 12.6179Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4672_1190",
    x: 0,
    y: 0,
    width: 19.877,
    height: 19.877,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4672_1190"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4672_1190",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4672_1190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.877,
    height: 11.877,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/iconWarning.cebbd574adcf7dd23e98917667ebd8cd.svg";
export { ForwardRef as ReactComponent };